<template>
  <div class="mt-component-form print-container mb-4">
    <vs-row class="my-4 center-flex">
      <h5><i class="dot"></i>{{ title }}</h5>
      <div class="ml-auto">
        <vs-button v-if="!isPrint" color="secondary" @click="handleAddRow">구성물질 추가</vs-button>
        <vs-button v-if="!isPrint" class="ml-4" color="secondary" type="border" @click="handleRemoveRow">선택삭제</vs-button>
      </div>
    </vs-row>

    <div class="w-full" style="overflow-x: auto">
      <table>
        <colgroup>
          <col v-if="!isPrint" width="66" />
          <col width="370" />
          <col width="370" />
          <col width="170" />
          <col width="100" />
          <col width="120" />
          <col width="120" />
          <col width="120" />
          <col width="120" />

          <col width="120" />
          <col width="120" />
          <col width="120" />
          <col width="120" />

          <col width="120" />
          <col width="120" />
          <col width="120" />
          <col width="120" />
        </colgroup>
        <thead>
          <tr>
            <th v-if="!isPrint" rowspan="2">
              <vs-checkbox v-model="tableAllCheck" class="custom-checkbox"></vs-checkbox>
            </th>
            <th colspan="4" style="background-color: #f0f0fd">
              <div class="flex justify-center items-center gap-3">
                <p>구성물질 및 함유량</p>
              </div>
            </th>
            <th colspan="12">주요관리항목</th>
          </tr>
          <tr>
            <th style="background-color: #f0f0fd">구성물질</th>
            <th style="background-color: #f0f0fd">CAS No.</th>
            <th style="background-color: #f0f0fd">함량(%)</th>
            <th style="background-color: #f0f0fd">성상</th>
            <th>특별관리물질</th>
            <th>관리대상물질</th>
            <th>작업환경측정</th>
            <th>특수건강검진</th>

            <th>인체급성유해성물질</th>
            <th>인체만성유해성물질</th>
            <th>생태유해성물질</th>
            <th>허가물질</th>

            <th>제한물질</th>
            <th>금지물질</th>
            <th>사고대비물질</th>
            <th>배출량조사대상물질</th>
          </tr>
        </thead>
        <tbody is="draggable" :list="tableList" tag="tbody" handle=".handle">
          <!-- rows -->
          <tr v-for="(rows, indexRows) in tableList" :key="indexRows">
            <td v-if="!isPrint">
              <div class="flex items-center justify-center">
                <feather-icon class="handle" icon="MenuIcon" style="width: 14px; height: 14px; cursor: pointer" />
                <vs-checkbox v-model="rows.is_checked" class="custom-checkbox"></vs-checkbox>
              </div>
            </td>

            <!--  =========== 구성성분정보 ============== -->
            <td>
              <div class="chem-select-input" :class="{ 'is-locked': isReadonly }" style="display: flex; position: relative; align-items: center">
                <ml-input class="w-full" :isPrint="isPrint" readonly v-model="rows.구성물질" placeholder="구성물질명" @click="openChemSearchPopup(indexRows)" />
                <vs-icon
                  v-if="!isPrint && !isReadonly"
                  icon-pack="feather"
                  icon="icon-search"
                  style="padding-left: 6px; padding-right: 6px; position: absolute; top: auto; right: 0; bottom: auto; font-size: 20px; border-left: 1px solid #cdcdcd; cursor: pointer"
                  @click="openChemSearchPopup(indexRows)"
                ></vs-icon>
              </div>
            </td>
            <td>{{ rows.CAS }}</td>
            <td>
              <div v-if="rows.함량.범위 === '없음'" class="flex justify-center items-center gap-2">
                <vs-button
                  class="py-1 px-2"
                  color="secondary"
                  @click="
                    () => {
                      rows.함량.범위 = '고정값';
                    }
                  "
                  >고정값</vs-button
                >
                <vs-button
                  class="py-1 px-2"
                  color="secondary"
                  type="border"
                  @click="
                    () => {
                      rows.함량.범위 = '범위';
                    }
                  "
                  >범위</vs-button
                >
              </div>
              <div v-if="rows.함량.범위 === '고정값'">
                <div class="flex gap-1 items-center">
                  <ml-input :isPrint="isPrint" v-model="rows.함량.min" placeholder="0" />
                  <feather-icon
                    icon="XIcon"
                    style="width: 24px; height: 24px; cursor: pointer"
                    @click="
                      () => {
                        rows.함량.범위 = '없음';
                        rows.함량.min = '';
                        rows.함량.max = '';
                      }
                    "
                  />
                </div>
              </div>
              <div v-if="rows.함량.범위 === '범위'">
                <div class="flex gap-1 items-center">
                  <ml-input :isPrint="isPrint" v-model="rows.함량.min" placeholder="0" />
                  <span>~</span>
                  <ml-input :isPrint="isPrint" v-model="rows.함량.max" placeholder="100" />
                  <feather-icon
                    icon="XIcon"
                    style="width: 24px; height: 24px; cursor: pointer"
                    @click="
                      () => {
                        rows.함량.범위 = '없음';
                        rows.함량.min = '';
                        rows.함량.max = '';
                      }
                    "
                  />
                </div>
              </div>
            </td>
            <td><ml-input :isPrint="isPrint" v-model="rows.성상" placeholder="액체" /></td>
            <!--  =========== 구성성분정보END ============== -->

            <!-- 주요관리항목은 구성물질 검색 결과로만 자동 반영되며, 수동으로 체크할 수 없다(표시 전용) -->
            <!-- 주요관리항목 / 특별관리물질 -->
            <td><PrintCheckbox :value="rows.특별관리물질" color class="justify-center" /></td>
            <!-- 주요관리항목 / 관리대상물질 -->
            <td><PrintCheckbox :value="rows.관리대상물질" color class="justify-center" /></td>
            <!-- 주요관리항목 / 작업환경측정 -->
            <td><PrintCheckbox :value="rows.작업환경측정" color class="justify-center" /></td>
            <!-- 주요관리항목 / 특수건강검진 -->
            <td><PrintCheckbox :value="rows.특수건강검진" color class="justify-center" /></td>

            <!-- 주요관리항목 / 인체급성유해성물질 -->
            <td><PrintCheckbox :value="rows.인체급성유해성물질" color class="justify-center" /></td>
            <!-- 주요관리항목 / 인체만성유해성물질 -->
            <td><PrintCheckbox :value="rows.인체만성유해성물질" color class="justify-center" /></td>
            <!-- 주요관리항목 / 생태유해성물질 -->
            <td><PrintCheckbox :value="rows.생태유해성물질" color class="justify-center" /></td>
            <!-- 주요관리항목 / 허가물질 -->
            <td><PrintCheckbox :value="rows.허가물질" color class="justify-center" /></td>

            <!-- 주요관리항목 / 제한물질 -->
            <td><PrintCheckbox :value="rows.제한물질" color class="justify-center" /></td>
            <!-- 주요관리항목 / 금지물질 -->
            <td><PrintCheckbox :value="rows.금지물질" color class="justify-center" /></td>
            <!-- 주요관리항목 / 사고대비물질 -->
            <td><PrintCheckbox :value="rows.사고대비물질" color class="justify-center" /></td>
            <!-- 주요관리항목 / 배출량조사대상물질 -->
            <td><PrintCheckbox :value="rows.배출량조사대상물질" color class="justify-center" /></td>
          </tr>
        </tbody>
      </table>
    </div>

    <popup-chem-substance-search v-model="showChemSearchPopup" @select="onSelectChemSubstance" />
  </div>
</template>

<script>
import draggable from "vuedraggable";
import CustomOptionSelector from "@/components/selector/CustomOptionSelector.vue";
import FileUploader from "@/components/FileUploader.vue";
import NumberInput from "@/components/NumberInput.vue";
import PrintCheckbox from "@/components/print/PrintCheckbox.vue";
import PopupChemSubstanceSearch from "./PopupChemSubstanceSearch.vue";
import { MAIN_MANAGEMENT_FIELDS } from "./kecoChemApi";

export default {
  components: {
    FileUploader,
    CustomOptionSelector,
    draggable,
    NumberInput,
    PrintCheckbox,
    PopupChemSubstanceSearch,
  },
  props: {
    title: {
      type: String,
      default: () => "MSDS",
    },
    value: Array,
    isPrint: Boolean,
    isReadonly: Boolean,
  },
  data() {
    return {
      tableList: this.value,
      showChemSearchPopup: false,
      chemSearchRowIndex: -1,
    };
  },
  computed: {
    tableAllCheck: {
      get() {
        if (this.tableList.length > 0) {
          return this.tableList.every((data) => data.is_checked);
        }
        return false;
      },
      set(value) {
        for (const data of this.tableList) {
          data.is_checked = value;
        }
      },
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        if (value && value.length > 0) {
          this.tableList = value;
        }
      },
    },
    tableList(value) {
      this.$emit("input", value);
    },
  },
  created() {
    if (this.tableList.length === 0) {
      this.handleAddRow();
    }
  },
  methods: {
    checkForm(value, indexRows, text) {
      if (value.target.checked) {
        this.$emit("update-list-check", indexRows - 1, text);
      } else {
        this.$emit("update-list-check", indexRows - 1, "");
      }
    },
    // 항목추가
    handleAddRow() {
      const row = {
        is_checked: this.tableAllCheck,

        구성물질: "",
        CAS: "",
        함량: {
          범위: "없음",
          min: "",
          max: "",
        },
        성상: "",
      };
      for (const field of MAIN_MANAGEMENT_FIELDS) {
        row[field] = false;
      }
      this.tableList.push(row);
      this.updateList();
    },
    // 구성물질명 검색
    openChemSearchPopup(rowIndex) {
      if (this.isReadonly) return;
      this.chemSearchRowIndex = rowIndex;
      this.showChemSearchPopup = true;
    },
    onSelectChemSubstance(chem) {
      const row = this.tableList[this.chemSearchRowIndex];
      if (!row) return;
      row.구성물질 = chem.name || "";
      row.CAS = chem.casNo || "";

      // 주요관리항목은 검색 결과 기준으로만 자동 반영한다(수동 체크 불가) - 새 구성물질을 고를 때마다
      // 이전 선택의 체크가 남지 않도록 전부 초기화한 뒤, 이번 검색 결과에 매칭되는 항목만 다시 체크한다.
      const 주요관리항목 = chem.주요관리항목 || {};
      for (const field of MAIN_MANAGEMENT_FIELDS) {
        row[field] = !!주요관리항목[field];
      }
    },
    // 선택삭제
    handleRemoveRow() {
      for (let i = 0; i < this.tableList.length; i++) {
        if (this.tableList[i].is_checked) {
          this.tableList.remove(this.tableList[i]);
          i = -1;
        }
      }
      if (this.tableList.length === 0) {
        this.handleAddRow();
      }
      this.updateList();
    },
    // update
    updateList() {
      this.$emit("updateList", this.tableList);
    },
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
$bg: #f9f9f9;

.chem-select-input::v-deep {
  width: 100%;

  .vs-input--input.normal {
    padding-right: 32px !important;
    cursor: pointer;
  }

  // 클릭으로 검색 팝업을 열기 위해 readonly 속성을 사용하지만, 폼 자체가 읽기전용인 경우가 아니라면
  // MaxLengthInput 의 전역 readonly 배경색(#fafafa) 대신 흰 배경을 유지한다
  .vs-inputx[readonly] {
    background-color: #fff !important;
  }
}

.chem-select-input.is-locked::v-deep {
  .vs-inputx[readonly] {
    background-color: #fafafa !important;
  }
}

.custom-checkbox::v-deep {
  justify-content: center !important;
  .vs-checkbox {
    margin: 0 !important;
  }
}

table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  th {
    font-weight: 700;
    font-size: 14px;
    text-align: center;

    background-color: #f9f9f9;
    border: 1px solid #cdcdcd;

    padding: 7px 11px;
  }

  td {
    font-weight: 400;
    font-size: 14px;
    text-align: center;

    border: 1px solid #cdcdcd;
    padding: 7px;
  }

  .tditem {
    & > * {
      border-right: 1px solid #cdcdcd;
      border-bottom: 1px solid #cdcdcd;
      padding: 7px;
      &:last-child {
        border-right: 0;
      }
    }

    &:last-child > * {
      border-bottom: 0;
    }
  }
}
</style>
